import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, Col, DatePicker, Divider, Form, Input, Row, Select, Space } from "antd";
import { useEffect } from "react";
import { NumericFormat } from "react-number-format";
import { PagamentoContaFinanceiraModel } from "../../../../../../models/pagamentoContaFinanceira/pagamentoContaFinanceiraModel";
import { setModalPagamentoUnico } from "../../../../../../redux/slices/pagamentoContaFinanceira/pagamentoContaFinanceiraSlice";
import { atualizarPagamentoContaFinanceira, cadastrarPagamentoContaFinanceira } from "../../../../../../services/pagamentoContaFinanceiraService";
import { realParaNumber } from "../../../../../../util/dinheiroBRAuxiliar";
import { useAppDispatch, useAppSelector } from "../../../../../../util/hooks";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import { PagamentoContaFinanceiraVWModel } from "../../../../../../models/pagamentoContaFinanceira/pagamentoContaFinanceiraVWModel";
import { buscarContaBanco } from "../../../../../../services/contaBancoService";
import { Vm_ContaBancoModel } from "../../../../../../models/contaBanco/vm_contaBancoModel";
import { buscarFormaPagamentoRecebimento } from "../../../../../../services/formaPagamentoRecebimentoService";

dayjs.locale("pt-br");

const CadastroPagamento = () => {
  //estados globais
  const pagamentoContaFinanceiraState = useAppSelector((state) => state.pagamentoContaFinanceira);
  const contaBancoState = useAppSelector((state) => state.contaBanco);
  const formaPagamentoRecebimentoState = useAppSelector((state) => state.formaPagamentoRecebimento);

  //hooks
  const dispatch = useAppDispatch();

  //estados locais
  const [form] = Form.useForm<PagamentoContaFinanceiraVWModel>();

  const editar = Object.values(pagamentoContaFinanceiraState.entity).length !== 0;

  useEffect(() => {
    if (formaPagamentoRecebimentoState.list.length === 0) dispatch(buscarFormaPagamentoRecebimento(formaPagamentoRecebimentoState.busca));
    dispatch(
      buscarContaBanco({
        pesquisar: null,
        id: pagamentoContaFinanceiraState.entity.idContaBanco,
        idEmpresa: null,
      })
    );
    if (editar) {
      form.setFieldsValue({ ...pagamentoContaFinanceiraState.entity, data: dayjs(pagamentoContaFinanceiraState.entity.data) });
      handleCalculoValorTotal();
    }
  }, [pagamentoContaFinanceiraState.entity]);

  const submit = (value: any) => {
    const submitPagamento: PagamentoContaFinanceiraModel = { ...value };
    submitPagamento.idContaFinanceira = pagamentoContaFinanceiraState.idContaFinanceira;
    if (editar) {
      submitPagamento.id = pagamentoContaFinanceiraState.entity.id;
      dispatch(atualizarPagamentoContaFinanceira({ value: submitPagamento, busca: pagamentoContaFinanceiraState.idContaFinanceira }));
    } else {
      dispatch(cadastrarPagamentoContaFinanceira({ value: submitPagamento, busca: pagamentoContaFinanceiraState.idContaFinanceira }));
    }
  };

  const handleCalculoValorTotal = () => {
    form.setFieldsValue({
      total: form.getFieldValue("valor") + form.getFieldValue("juros") + form.getFieldValue("multa") + form.getFieldValue("outrosValores") - form.getFieldValue("desconto"),
    });
  };

  const voltar = () => {
    dispatch(setModalPagamentoUnico(false));
  };

  return (
    <Form form={form} onFinish={submit} layout="vertical" onChange={handleCalculoValorTotal}>
      <Row gutter={12}>
        <Col span={12}>
          <Form.Item
            label="Conta bancária"
            name="idContaBanco"
            rules={[
              {
                required: true,
                message: "Escolha a conta bancária",
              },
            ]}
          >
            <Select
              options={contaBancoState.list.map((a: Vm_ContaBancoModel) => ({
                value: a.id,
                label: a.denominacaoPersonalizada,
                disabled: !a.ativo,
              }))}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Tipo de transação bancária"
            name="idFormaPagamentoRecebimento"
            rules={[
              {
                required: true,
                message: "Selecione o tipo de transação bancária",
              },
            ]}
          >
            <Select
              options={formaPagamentoRecebimentoState.list.map((a: any) => ({
                value: a.id,
                label: a.denominacao,
                disabled: !a.ativo,
              }))}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12} justify="space-between">
        <Col>
          <Form.Item
            label="Data"
            name="data"
            rules={[
              {
                required: true,
                message: "Digite a data",
              },
            ]}
          >
            <DatePicker format="DD/MM/YYYY" style={{ width: "142px" }} />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item
            label="Valor Principal"
            name="valor"
            rules={[
              {
                required: true,
                message: "Digite o valor principal",
              },
            ]}
          >
            <NumericFormat
              className="ant-input noBoderColor number-input"
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              prefix="R$"
              fixedDecimalScale={true}
              style={{ width: "142px" }}
              onChange={() => form.setFieldValue("valor", realParaNumber(form.getFieldValue("valor")))}
            />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item
            label="Juros"
            name="juros"
            rules={[
              {
                required: true,
                message: "Digite o valor do juros",
              },
            ]}
          >
            <NumericFormat
              className="ant-input noBoderColor number-input"
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              prefix="R$"
              style={{ width: "142px" }}
              fixedDecimalScale={true}
              onChange={() => form.setFieldValue("juros", realParaNumber(form.getFieldValue("juros")))}
            />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item
            label="Multa"
            name="multa"
            rules={[
              {
                required: true,
                message: "Digite o valor da multa",
              },
            ]}
          >
            <NumericFormat
              className="ant-input noBoderColor number-input"
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              prefix="R$"
              style={{ width: "142px" }}
              fixedDecimalScale={true}
              onChange={() => form.setFieldValue("multa", realParaNumber(form.getFieldValue("multa")))}
            />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item label="Outros valores" name="outrosValores">
            <NumericFormat
              className="ant-input noBoderColor number-input"
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              prefix="R$"
              style={{ width: "142px" }}
              fixedDecimalScale={true}
              onChange={() => form.setFieldValue("outrosValores", realParaNumber(form.getFieldValue("outrosValores")))}
            />
          </Form.Item>
        </Col>
        <Col>
          <Form.Item
            label="Desconto"
            name="desconto"
            rules={[
              {
                required: true,
                message: "Digite o valor do desconto",
              },
            ]}
          >
            <NumericFormat
              className="ant-input noBoderColor number-input"
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              prefix="R$"
              style={{ width: "142px" }}
              fixedDecimalScale={true}
              onChange={() => form.setFieldValue("desconto", realParaNumber(form.getFieldValue("desconto")))}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={4}>
          <Form.Item label="Valor total" name="total">
            <NumericFormat
              className="ant-input noBoderColor number-input"
              thousandSeparator="."
              decimalSeparator=","
              decimalScale={2}
              prefix="R$"
              disabled
              style={{ width: "142px" }}
              fixedDecimalScale={true}
              onChange={() => form.setFieldValue("total", realParaNumber(form.getFieldValue("total")))}
            />
          </Form.Item>
        </Col>
        <Col span={20}>
          <Form.Item label="Histórico" name="historico">
            <Input type="text" placeholder="Digite uma descrição" />
          </Form.Item>
        </Col>
      </Row>
      <Divider />
      <Row gutter={12}>
        <Col span={24} className="modalFooter">
          <Space size="middle">
            <Button className="cancelButton" onClick={voltar} icon={<CloseOutlined />}>
              FECHAR
            </Button>
            <Button htmlType="submit" icon={<CheckOutlined />} className="buttonPrimary">
              {editar ? "ATUALIZAR" : "SALVAR"}
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
};

export default CadastroPagamento;
